/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Type of the required data
 */
export enum RequiredDataType {
    PAYMENT = 'PAYMENT',
    CONSENT = 'CONSENT',
}
